import { Box, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '医生建议您接受由志愿者捐献的血液或血液制品的输血。',
  '输血是为了替换您的一部分血液，适用于以下情况：',
  '替换红细胞以治疗或预防贫血，改善氧气运输并缓解头晕、疲劳或呼吸困难的症状',
  '提供血小板以帮助停止或预防出血。',
  '提供血浆制品以停止、治疗或预防出血。',
  '输血通过静脉中的针（套管）或通过中心静脉导管进入您的静脉进行。在输血期间，您将被密切监测以防任何可能的反应。您还将定期检查是否需要再次输血。',
  '医生已解释我需要输血的医疗状况：（医生用患者自己的话记录）',
];

const BContents = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="B. 為什麼我需要輸血?" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 20px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i > 1 && i < 5) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                • {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>
      <Box
        sx={{
          width: '98%',
          margin: '0px auto 20px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          您的醫療狀況需要以下血液製品。
          <br />
          醫生列出產品和治療頻率。（醫生可以指定在治療過程中頻率可能會有所變化）
        </Typography>
      </Box>
    </>
  );
};

export default BContents;
